/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EditConfirm.vue?vue&type=template&id=4b8c57b8&scoped=true&"
import script from "./EditConfirm.vue?vue&type=script&setup=true&lang=js&"
export * from "./EditConfirm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EditConfirm.vue?vue&type=style&index=0&id=4b8c57b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c57b8",
  null
  
)

export default component.exports